import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, OnInit, Output } from "@angular/core";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { VirtualLocationDTO } from "src/app/features/map-features/ui/organisms/route-sheet/models/VirtualLocationDTO";
@Injectable({
  providedIn: "root",
})
export class VirtualLocationsAPIService implements IApiBase{
  
  private configUrl = "";
  public Result;
  httpHeaders: HttpHeaders = new HttpHeaders();
  
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }

  getLocationCategoryChilds(parentIdentifier: string): any {
    if(!environment.production) console.log("/api/Location/GetLocationCategoryChilds/");
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/VirtualLocation/GetLocationCategoryChilds?parentIdentifier=" + parentIdentifier,
      {}
    );
  }
  getChilds(parentIdentifier: string, idLocationCategoryChild: number): any {
    if(!environment.production) console.log("/api/Location/postValidateIdentifiers/", parentIdentifier, idLocationCategoryChild);
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/VirtualLocation/GetRouteSheet?parentIdentifier=" + parentIdentifier + "&idLocationCategory=" + idLocationCategoryChild, {}
    );
  }
  getChildrenFilteredByIdentifier(parentIdentifier: string, searchValue: string, childCategory: number): any {
    if(!environment.production) console.log("/api/Location/postValidateIdentifiers/", parentIdentifier, searchValue, childCategory);
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/VirtualLocation/GetChildrenFilteredByIdentifier?parentIdentifier=" + parentIdentifier + "&searchValue=" + searchValue + "&childCategory=" + childCategory, {}
    );
  }

  getProspectsList(identifier: string, idLocationCategory: number, filter: string, includeGeojson: boolean, calculateByDistance: boolean, isForcedReload: boolean): any {
    const url = this.configUrl + "/api/VirtualLocation/GetProspectsList?identifier=" + identifier + "&idLocationCategory=" + idLocationCategory + "&filter=" + filter + "&includeGeojson=" + includeGeojson + "&calculateByDistance=" + calculateByDistance + "&isForcedReload=" + isForcedReload;
    if(!environment.production) console.log(url);
    return this.http.get<EstatusJSON>(url, {});
  }

  createOrUpdateVirtualLocation(virtualLocationDTO: VirtualLocationDTO): any {
    if(!environment.production) console.log("/api/VirtualLocation/CreateOrUpdateVirtualLocation/", virtualLocationDTO);
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/VirtualLocation/CreateOrUpdateVirtualLocation", virtualLocationDTO, {}
    );
  }

  createOrUpdateProspectLocation(virtualLocationDTO: VirtualLocationDTO, idLocationCategoryStatus: number): any {
    var request = {
      identifier: virtualLocationDTO.identifier,
      data: virtualLocationDTO.data,
      idLocationCategoryStatus: idLocationCategoryStatus,
    }
    if(!environment.production) console.log("/api/VirtualLocation/UpdateProspectLocation/", virtualLocationDTO);
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/VirtualLocation/UpdateProspectLocation", request, {}
    );
  }
  
}
